// Number / currency formatting helpers used across the staff portal
// (numberFormatter → Preloan/EligCheck + Payments/Recents; roundNum +
// commissionCalc → utils/paymentValues.js).
//
// This file previously also held the entire client-side loan pricing engine
// (getCustomerRate, get*Eligibility, scoring, etc.). That engine moved to
// loan-service and is now consumed via
//   POST /loans/staff/apply/:slug?mode=preview
// (see utils/loanProcessing.js), so only these formatting utilities remain.

const roundNum = (number, precisionIn) => {
    let precision = precisionIn || 2;
    let rounded = (Math.round(number * Math.pow(10, precision)) / Math.pow(10,precision)).toFixed(precision);
    return parseFloat(rounded);
}

const numberFormatter = (num) => {
    return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const commissionCalc = (rate, duration, amount) => {
    let interest = roundNum(((rate / 100) / duration), 2);
    let perMonth = roundNum(((rate / 100) / duration) * amount, 2);
    let total = roundNum(perMonth * duration, 2);

    return { interest, perMonth, total }
}

export {
    roundNum,
    numberFormatter,
    commissionCalc
}
